export default __webpack_public_path__ + "static/media/credit-card.1c1071c2.svg";